module.exports = __webpack_public_path__ + "static/school_obj5@2x-bcfc17053f9fb4a125aa027cea159677.png";